/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Real from 'canvas/base/dev/child/base/B_Real';
import B_ChildTool from 'canvas/base/dev/child/base/B_ChildTool';
import B_Shape from 'canvas/base/dev/child/shape/B_Shape';
import B_Define from 'canvas/base/dev/util/B_Define';
import B_Button from 'canvas/base/dev/child/button/B_Button';
let mix = (superclass) => new MixinBuilder(superclass);

const B_ToolDisabled = (function(){

	const CLICK_MAINTAIN_TIME = 500; // 클릭유지시간

	class B_ToolDisabled extends mix(B_Real).with(B_ChildTool, B_Shape, B_Button) {

		constructor(obj) {
			super(obj);
			this._makeShape(); // [#] init shape
			this._visible = false; // [#] init visible
			this._isClicked = false; // [#] init isClicked

			// [#] click event listener
			this.click((event) => {

				// [#] 캔버스가 아직 활성화 상태인가요 ?
				if(!this.CODMOS.boolEnd) {

					// [#] 중복 클릭은 아닌가요 ?
					if(!this._isClicked) {

						// [#] 중복클릭을 방지하기 위한 클릭 유지시간 설정
						this._isClicked = true;
						setTimeout(()=>{ this._isClicked = false; }, CLICK_MAINTAIN_TIME);

						// [#] popup이 활성화 되어 있나요 ?
						if(this.CODMOS.TOOL[B_Define.POPUP_ID].isOpenPopup) {

							// [#] 팝업 닫기 & 비활성화 해제
							this.CODMOS.TOOL.popup.close(); // <= this.toggle(); 속에 존재
						}
						else {
							// [#] 비활성화 해제
							this.toggle();
						}

					}
				}

			});
		}

        // [F]

		/**
		 * @DES :: shpae init
		 * @S.E :: this._object 사용
		 */
		_makeShape() {
			this._object.graphics
				.beginFill(B_Define.DISABLED_COLOR) // [*] black
				.drawRect( 0, 0, this.CODMOS.CANVAS.width, this.CODMOS.CANVAS.height ); // [*] full canvas size
			this._object.alpha = B_Define.DISABLED_ALPHA_DARK; // [*] alpha
		}

		/**
		 * @DES :: disabled 객체 알파값 설정하기
		 * @IP1 :: alpha {num}
		 * @O.P :: null
		 * @S.E ::
		 */
		setAlpha(numAlpha) {
			this._object.alpha = numAlpha;
		}

		/**
		 * @DES :: visible toggle
		 * @IP1 :: boolVisible {bool}
		 * @O.P :: null
		 * @S.E :: this._visible 사용
		 */
		toggle(boolVisible) {
			let changedVisible;
			if(typeof boolVisible == 'undefined') {
				changedVisible = !this._visible;
			}
			else {
				changedVisible = boolVisible;
			}
			this._visible = changedVisible;
		}

	}

	return B_ToolDisabled;
}());

export default B_ToolDisabled;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/tool/B_ToolDisabled.js